import { isMockMode, post, simulateDelay } from "../api";

export const getLicencesWithUsers = ({ orgId, ...rest }) => {
	if (isMockMode()) {
		const testData = {
			totalAvailable: 0,
			fetchedCount: 0,
			paginationMetadata: {
				pageNo: 0,
				pageSize: 0,
				totalPages: 0,
			},
			skippedCount: 0,
			results: [
				{
					id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					isRevoked: true,
					isSubEnabled: true,
					offering: {
						id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
						name: "string",
						websiteLinkUrl: "string",
					},
					subscription: {
						id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
						name: "string",
					},
					activeMachine: "string",
					lastUsedAgentString: "string",
					assignedByUser: {
						id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
						email: "string",
						firstName: "Test",
						lastName: "McTestie",
					},
					assignedToUser: {
						id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
						email: "string",
						firstName: "Test",
						lastName: "McTestie",
					},
					subExpirationUtc: "2026-03-30T01:01:17.194Z",
					assignedDateUtc: "2026-03-30T01:01:17.194Z",
					licenceExpirationUtc: "2026-03-30T01:01:17.194Z",
					lastActivatedUtc: "2026-03-30T01:01:17.194Z",
					cooldownUntilUtc: "2026-03-30T01:01:17.194Z",
					lastUsedUtc: "2026-03-30T01:01:17.194Z",
					state: "Expired",
				},
			],
			orgId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		};

		return simulateDelay(50, () => testData);
	}

	return post(`OrgUsers/GetLicencesForOrg`, {
		orgId,
		...rest,
	});
};
